import type { PriceConflict } from "@/forwards2/forwardsTypes";
import { useI18n } from "vue-i18n";

/**
 * How a price conflict names its mandates: each with what it pays, "A at 18.500 and B at 20.000".
 * A mandate paying the delivery's price while the delivery has none reads as such.
 */
export const usePriceConflictText = () => {
  const { t } = useI18n();
  return (conflict: PriceConflict): string =>
    conflict.mandates
      .map((mandate) =>
        t("forwards.deals.price_conflict.mandate_at", {
          mandate: mandate.mandate_name,
          price:
            mandate.unit_price ?? t("forwards.deals.price_conflict.no_price"),
        })
      )
      .join(t("forwards.deals.price_conflict.and"));
};
